import { exportTableToPdf } from '../exportTableToPdf';
import { getObservationsPdfCellStyle, OBSERVATIONS_BADGE_COLUMNS } from '../pdfCellStyles';
import {
    filterRowsByIds,
    formatPdfDate,
    formatPlainText,
    getVisibleColumnsFromState,
    stripHtmlToPlainText,
} from '../pdfTextUtils';

const OBS_COLUMN_ORDER = ['number', 'tags', 'observation', 'significance', 'rag', 'swot', 'claim', 'addedOn', 'addedBy'];

const COLUMN_WEIGHTS = {
    number: 1,
    tags: 1.1,
    observation: 3,
    significance: 2,
    rag: 0.8,
    swot: 1.1,
    claim: 0.7,
    addedOn: 1.1,
    addedBy: 1.2,
};

const SWOT_LABELS = { S: 'Strength', W: 'Weakness', O: 'Opportunity', T: 'Threat' };
const RAG_LABELS = { RED: 'Red', AMBER: 'Amber', GREEN: 'Green' };

export const exportObservationsToPdf = async ({
    rows,
    columnState,
    projectUsersAll = [],
    projectName,
    workstreamName,
    selectedRowIds = null,
    filename = 'observations.pdf',
}) => {
    const visibleColumns = getVisibleColumnsFromState(columnState).sort(
        (a, b) => OBS_COLUMN_ORDER.indexOf(a.key) - OBS_COLUMN_ORDER.indexOf(b.key),
    );

    const filteredRows = filterRowsByIds(rows, selectedRowIds);

    const getUserName = userId =>
        formatPlainText(projectUsersAll.find(u => u?.value?.user_id === userId)?.value?.full_name || 'Project Admin');

    const getCellValue = (row, columnKey) => {
        switch (columnKey) {
            case 'number':
                return formatPlainText(row.number || row.id || '');
            case 'tags':
                return formatPlainText(row.tag_repr || '');
            case 'observation':
                return stripHtmlToPlainText(row.observation || '');
            case 'significance':
                return stripHtmlToPlainText(row.comments || '');
            case 'rag':
                return RAG_LABELS[row.assessment] || row.assessment || '';
            case 'swot':
                return SWOT_LABELS[row.swot] || row.swot || '';
            case 'claim':
                return row.claim ? 'Yes' : '';
            case 'addedOn':
                return formatPdfDate(row.created);
            case 'addedBy':
                return getUserName(row.added_by);
            default:
                return '';
        }
    };

    const title = workstreamName ? `Observations — ${workstreamName}` : 'Observations';

    await exportTableToPdf({
        title,
        projectName,
        visibleColumns,
        rows: filteredRows,
        getCellValue,
        getCellStyle: (row, columnKey) => getObservationsPdfCellStyle(columnKey, row),
        columnWeights: COLUMN_WEIGHTS,
        badgeColumns: OBSERVATIONS_BADGE_COLUMNS,
        filename,
    });
};
